import clsx from 'clsx';

import type { Template } from '@commons/components/RichText/templates';
import Spacer from '@commons/components/Spacer';

import styles from './FillSpacer.module.scss';

/**
 * Fill Spacer CKEditor template.
 *
 * @returns A rendered React component.
 */

const FillSpacerTemplate: Template = () => (
  <Spacer size="md" className={clsx(styles.fillSpacer, 'w-100', 'flex-fill')} />
);

export default FillSpacerTemplate;
